import React from 'react'
import { Navbar, Footer } from "../../components"
import { ClientSolarLogin } from "."
export default function SignUp() {
  return (
    <div className='emas__signup'>
        <Navbar />
        <ClientSolarLogin />
        <Footer />
    </div>
  )
}
